// One cell/header token set for DataTable and PanelTable (DESIGN.md §4.5); they differ in behavior only.
export const TABLE_BORDER = 'rounded-lg border border-gray-200 dark:border-gray-800';
export const TABLE_FRAME = `relative overflow-hidden ${TABLE_BORDER}`;
export const TABLE_DIVIDER = 'border-r border-gray-200 dark:border-gray-800';
export const TABLE_TH =
  'px-6 py-4 text-xs font-semibold uppercase tracking-wider text-gray-600 dark:text-gray-400';
export const TABLE_TD = 'px-6 py-4 text-sm text-gray-800 dark:text-gray-200';
export const TABLE_HEAD_ROW = 'border-b border-gray-200 dark:border-gray-800';
export const TABLE_ROW = 'border-b border-gray-200 dark:border-gray-800 last:border-b-0';
export const TABLE_ROW_HOVER = 'transition-colors hover:bg-gray-50 dark:hover:bg-white/[0.03]';
export const TABLE_BODY = 'bg-white dark:bg-gray-900';

// The Actions column stays pinned to the right edge while the frame scrolls sideways; its own left line
// replaces the divider of the column before it. The line is a 1px ::before, not border-l: preflight's
// border-collapse makes cell borders part of the table grid, so a sticky cell's border wouldn't move with it.
export const TABLE_PINNED_ACTIONS =
  'sticky right-0 z-10 bg-white dark:bg-gray-900 before:absolute before:inset-y-0 before:left-0 before:w-px before:bg-gray-200 dark:before:bg-gray-800';

// The first column (and the selection checkbox before it) stays pinned to the left edge the same way, so a
// row keeps its name in view; its right line is a 1px ::after for the same reason. `left-16` clears the
// checkbox column when the table is selectable.
export const tablePinnedStart = (offset: 'left-0' | 'left-16') =>
  `sticky ${offset} z-10 bg-white dark:bg-gray-900 after:absolute after:inset-y-0 after:right-0 after:w-px after:bg-gray-200 dark:after:bg-gray-800`;

// The checkbox column is exactly 4rem (px-6 either side of a size-4 box), so the pinned first column can sit at left-16.
export const TABLE_SELECT_COL = 'w-16 min-w-16';

/** A column draws a right divider unless it is last or the pinned actions column follows it. */
export const hasDivider = (ids: (string | undefined)[], index: number) =>
  index < ids.length - 1 && ids[index + 1] !== 'actions';
